/*global fbq*/

import ReactGA from 'react-ga'

import {
  UPDATE_SIGNUP_DATA,
  ACCEPT_PROPOSAL_RESPONSE
} from './actions'

const getConversionValue = (cvv) => {
  return cvv || 0
}

const fbqPurchase = (value) => {
  if (typeof fbq !== "undefined") {
    fbq('track', 'Purchase', {
      'currency': 'JPY',
      'value': value,
    })
  }
}

const analyticsLogger = store => next => action => {
  // Log page changes to Google Analytics
  if (action.type === '@@router/LOCATION_CHANGE') {
    const realPathname = window.location.pathname + window.location.search + window.location.hash
    ReactGA.pageview(realPathname)
  }

  // Log conversion events to Google AdWords & Analytics
  // NOTE(keita): Hardcoded step number here; will need to change if step numbers change..
  // NOTE(keita): CHANGE_REQUEST_EDIT_STEP is used for /request/edit (but the user should already have paid by then, so
  // it doesn't need to be a conversion event)
  if (action.type === UPDATE_SIGNUP_DATA && action.payload && action.payload.step === 5) {
    let cvv = getConversionValue(action.payload.conversion_value)
    ReactGA.event({
      'category': 'conversion',
      'action': 'Finished signup',
      'value': cvv,
    })
    fbqPurchase(cvv)
  }

  if (action.type === ACCEPT_PROPOSAL_RESPONSE && action.payload) {
    let cvv = getConversionValue(action.payload.conversion_value)
    ReactGA.event({
      'category': 'conversion',
      'action': 'Report purchase',
      'value': cvv,
    })
    fbqPurchase(cvv)
  }

  return next(action)
}

export { analyticsLogger }



// WEBPACK FOOTER //
// ./src/modules/analytics.js